import axios from "axios";
import PropTypes from 'prop-types';

/**
 * Função que obtém o endereço IP do usuário.
 * @function getIpAddress
 * @returns {Promise<string>} - Uma promessa que resolve com o endereço IP do usuário.
 * 
 * @example
 * getIpAddress().then(ip => console.log(ip)); // "192.168.1.1"
 */
export const getIpAddress = async () => {
  const urlCall = process.env.REACT_APP_IP_API_URL || 'https://api64.ipify.org';
  const response = await axios.get(urlCall);
  if(response instanceof Error) {
    return "0";
  }
  return response.data;
}

// getUserIPAddress.propTypes = {}; // Remover ou corrigir se necessário

export default getIpAddress;
